import { Brand, createBranded } from '@deltasierra/type-utilities';

export type ClientId = Brand<number, 'ClientId'>;
export const ClientId = createBranded<ClientId>();
